import { Component } from '@opten/compiler/metadata/component';
import { setCookie } from '@opten/cookie/set';
import { getCookie } from '@opten/cookie/get';
import { debounce } from '@opten/reactive/debounce';

@Component({ className: 'js-cookie-banner' })
export class CookieBanner {
	private body = document.body;

	constructor(private element: HTMLElement) {
		if (getCookie('cookiesAccepted') !== 'true') {
			this.element.style.display = 'block';
			this.setSpace();
			window.addEventListener('resize', debounce((e) => {
				this.setSpace();
			}, 100));
			Array.from(document.getElementsByClassName('js-cookie-banner-accept'))
				.forEach((btn) => btn.addEventListener('click', (e) => {
					e.preventDefault();
					this.remove();
				}));
		} else {
			this.hide();
		}
	}

	private remove() {
		setCookie('cookiesAccepted', 'true', Infinity, '/');
		this.hide();
	}

	private hide() {
		this.element.style.display = 'none';
		this.body.removeAttribute('style');
	}

	private setSpace() {
		this.body.setAttribute('style', 'margin-bottom: ' + this.element.offsetHeight + 'px;');
	}
}
